import { useState, createContext, useContext } from "react";

const mode = createContext();

export const UseModeProvider = ({ children }) => {
  const screenWidth = window.screen.width;
  const [previewMode, setPreviewMode] = useState("full");

  return (
    <mode.Provider value={{ previewMode, setPreviewMode }}>
      {children}
    </mode.Provider>
  );
};

export const useModeConsumer = () => {
  return useContext(mode);
};
